import dayjs from 'dayjs';
import { getDefaultCountry } from './countriesUtils';

export const emptyPhoneValue = {
  countryIso2: 'ZA',
  countryIso3: 'ZAF',
  dialCode: '+27',
  nationalNumber: ''
};

export const phoneValueToString = (value) => {
  if (!value?.nationalNumber) return '';
  const dialCode = String(value.dialCode || '').replace(/[^\d+]/g, '');
  const nationalNumber = String(value.nationalNumber || '').replace(/\D/g, '');
  return `${dialCode}${nationalNumber}`;
};

export const parsePhoneValue = (phoneNumber, countries = []) => {
  const raw = String(phoneNumber || '').trim();
  const digits = raw.replace(/\D/g, '');
  if (!digits) return { ...emptyPhoneValue };

  const sortedCountries = [...countries].sort(
    (left, right) => String(right.code || '').length - String(left.code || '').length
  );
  const matchedCountry = sortedCountries.find((country) => {
    const dialDigits = String(country.code || '').replace(/\D/g, '');
    return raw.startsWith('+') && digits.startsWith(dialDigits);
  });
  const country = matchedCountry || getDefaultCountry(countries);
  const dialDigits = String(country?.code || '+27').replace(/\D/g, '');
  const nationalNumber = matchedCountry ? digits.slice(dialDigits.length) : digits.replace(/^0+/, '');

  return {
    countryIso2: country?.isoCode || 'ZA',
    countryIso3: country?.alpha3Code || 'ZAF',
    dialCode: country?.code || '+27',
    nationalNumber
  };
};

export const getFieldRules = (field) => {
  if (field?.fieldRules && typeof field.fieldRules === 'object') return field.fieldRules;
  if (typeof field?.fieldRules !== 'string') return {};
  try {
    return JSON.parse(field.fieldRules);
  } catch {
    return {};
  }
};

export const getCustomFieldName = (field) => `customField_${field.id}`;

export const serializeCustomFieldValue = (field, value) => {
  if (value === undefined) return undefined;
  if (field.fieldType === 'DatePicker' && dayjs.isDayjs(value)) return value.toISOString();
  if (field.fieldType === 'TimePicker' && dayjs.isDayjs(value)) return value.format('HH:mm');
  return value;
};
